// src/pages/Accounting/Reports/AccountList/components/ReportHeader.tsx
// Top row of the Account List report page body.
// Learn more + Give feedback (left) · Vela 3-for-you pill + Customize + Save As (right).
// The back link and breadcrumb live in the AppLayout pageHeader slot above
// (AccountListReportHeader exported from the page index).

import React from 'react';
import { BookOpen, MessageSquare, SlidersHorizontal } from 'lucide-react';

interface ReportHeaderProps {
  velaCount: number;
  onVelaClick: () => void;
  isCustomized: boolean;
  onCustomize: () => void;
  onSaveAs: () => void;
  onLearnMore?: () => void;
  onGiveFeedback?: () => void;
}

export default function ReportHeader(props: ReportHeaderProps) {
  return (
    <div className="pb-3 border-b border-lineSoft flex justify-between items-center gap-4 flex-wrap">
      <div className="flex items-center gap-4">
        <button
          type="button"
          onClick={props.onLearnMore}
          className="inline-flex items-center gap-1 text-teal-dark text-[12.5px] font-semibold border-none bg-transparent cursor-pointer hover:brightness-110"
        >
          <BookOpen size={13} strokeWidth={2} />
          Learn more
        </button>
        <button
          type="button"
          onClick={props.onGiveFeedback}
          className="inline-flex items-center gap-1 text-teal-dark text-[12.5px] font-semibold border-none bg-transparent cursor-pointer hover:brightness-110"
        >
          <MessageSquare size={13} strokeWidth={2} />
          Give feedback
        </button>
      </div>

      <div className="flex items-center gap-2.5">
        {props.velaCount > 0 && (
          <button
            type="button"
            onClick={props.onVelaClick}
            className="inline-flex items-center gap-2 h-9 pl-2 pr-3 rounded-full bg-vela-fade border border-vela-wash text-vela-deep text-[12.5px] font-bold cursor-pointer hover:brightness-95"
          >
            <span className="w-5 h-5 rounded-full bg-gradient-to-br from-[#7C3AED] to-[#6B46C1] text-white text-[10px] font-extrabold inline-flex items-center justify-center">
              V
            </span>
            Vela
            <span className="bg-white text-vela-deep text-[11px] font-bold px-2 py-0.5 rounded-full border border-vela-wash">
              {props.velaCount} for you
            </span>
          </button>
        )}
        <button
          type="button"
          onClick={props.onCustomize}
          className="inline-flex items-center gap-1.5 h-9 px-3.5 rounded-lg border border-line bg-white text-ink text-[12.5px] font-semibold cursor-pointer hover:bg-[#FAFBFB]"
        >
          <SlidersHorizontal size={13} strokeWidth={2} className="text-ink3" />
          Customize
          {props.isCustomized && <span className="w-[7px] h-[7px] rounded-full bg-teal-dark inline-block" />}
        </button>
        <button
          type="button"
          onClick={props.onSaveAs}
          className="h-9 px-4 rounded-lg bg-teal-dark text-white text-[12.5px] font-bold border-none cursor-pointer hover:brightness-110"
        >
          Save As
        </button>
      </div>
    </div>
  );
}